import {
  Model,
  ModelSnapshot,
} from 'src/containers/ProjectDiagram/types/model';
import {
  isModelConceptClass,
  isModelConceptRelationship,
} from 'src/containers/ProjectDiagram/utils/data';
import { getLabelForIri } from 'src/containers/ProjectDiagram/utils/labels';
import { getModelConceptClassValue } from 'src/containers/ProjectDiagram/utils/modelConceptClass/createModelConceptClass';
import { VoiceboxModelSchema } from 'src/utils/voicebox/types';

export const createVoiceboxModelSchema = ({
  model,
}: {
  model: Model | ModelSnapshot;
}): VoiceboxModelSchema => {
  const {
    linkDataArray,
    nodeDataArray,
    modelData: { attributesByIri, labelsByIri },
  } = model;

  const classIris = nodeDataArray
    .filter(isModelConceptClass)
    .map(({ value }) => value);

  const propertiesByIri: VoiceboxModelSchema['propertiesByIri'] = {};

  // add attributes
  Object.values(attributesByIri).forEach((data) => {
    const domains = Object.keys(data.domains);
    const ranges = Object.keys(data.ranges);
    propertiesByIri[data.value] = {
      iri: data.value,
      label: getLabelForIri(labelsByIri, data.value),
      isDatatype: true,
      domains: new Set(domains),
      ranges: new Set(ranges),
    };
  });

  // add relationships
  linkDataArray.filter(isModelConceptRelationship).forEach((data) => {
    if (!propertiesByIri[data.value]) {
      propertiesByIri[data.value] = {
        iri: data.value,
        label: getLabelForIri(labelsByIri, data.value),
        isDatatype: false,
        domains: new Set(),
        ranges: new Set(),
      };
    }

    if (data.from) {
      const fromIri = getModelConceptClassValue(data.from);
      propertiesByIri[data.value].domains.add(fromIri);
    }

    if (data.to) {
      const toIri = getModelConceptClassValue(data.to);
      propertiesByIri[data.value].ranges.add(toIri);
    }
  });

  return {
    classIris,
    labelsByIri,
    propertiesByIri,
  };
};
